/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents one item of a tile navigation consisting of predefined navigation items and sequence of display.
 */
export interface AnalyticProcessNavigation { 
    /**
     * ID of the AnalyticProcessNav tile item
     */
    id: number;
    /**
     * The associated AnalyticProcessGroupEntity is referenced using a foreign key
     */
    analyticProcessGroupId: number;
    /**
     * The type of the AnalyticProcess, e.g. KARTE_LISTE.
     */
    type?: string;
    /**
     * Flag that signals if the AnalyticProcess gets a navigation tile
     */
    hasTile?: boolean;
    /**
     * Sort property to determine the place in the tile navigation sequence
     */
    tileSort?: number;
    /**
     * JSON with the SVG icon properties \'filename\' \'size\' and \'color\'
     */
    tileIcon?: string;
    /**
     * The label text which is displayed in a navigation tile
     */
    tileLabel?: string;
    /**
     * When selecting this navigation, should the tiles be shown?
     */
    showTiles?: boolean;
    /**
     * When selecting this navigation, should the selection form be shown?
     */
    showAnalysisSelectionForm?: boolean;
    /**
     * When selecting this navigation, should the selectionForm should be disabled?
     */
    enableAnalysisSelectionForm?: boolean;
}

